import posthog from 'posthog-js';

// Check if analytics is enabled
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const PLAUSIBLE_DOMAIN = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;

export const isAnalyticsEnabled = () => {
  return Boolean(GA_MEASUREMENT_ID || PLAUSIBLE_DOMAIN || POSTHOG_KEY);
};

// Google Analytics event tracking
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, string | number>
) => {
  if (POSTHOG_KEY) {
      posthog.capture(eventName, eventParams);
  }

  if (GA_MEASUREMENT_ID && typeof window !== 'undefined' && 'gtag' in window) {
    // @ts-expect-error - gtag is loaded externally
    window.gtag('event', eventName, eventParams);
  } else if (PLAUSIBLE_DOMAIN && typeof window !== 'undefined' && 'plausible' in window) {
    // @ts-expect-error - plausible is loaded externally
    window.plausible(eventName, { props: eventParams });
  }
};

// Track page views (for SPA navigation)
export const trackPageView = (path: string) => {
    if (POSTHOG_KEY) {
        posthog.capture('$pageview');
    }

  if (GA_MEASUREMENT_ID && typeof window !== 'undefined' && 'gtag' in window) {
    // @ts-expect-error - gtag is loaded externally
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Convenient event trackers
export const analytics = {
  // User interactions
  bookingModalOpened: () => trackEvent('booking_modal_opened'),
  bookingCompleted: () => trackEvent('booking_completed'),
  ctaClicked: (location: string) => trackEvent('cta_clicked', { location }),

  // Navigation
  viewedSection: (section: string) => trackEvent('section_viewed', { section }),

  // Social proof
  caseStudyViewed: (company: string) => trackEvent('case_study_viewed', { company }),
  
  // AI Widget
  aiLeadCaptured: (service: string) => trackEvent('ai_lead_captured', { service }),

  // Custom events
  customEvent: (name: string, params?: Record<string, string | number>) =>
    trackEvent(name, params),
};
